module.exports = __webpack_public_path__ + "img/121.e31cf114.png";